import { useState } from 'react';
import './printSetupBanner.css';
import { LABEL_PRINTER_NAME, MIN_CHROME_MAJOR, POLICY_COMMANDS, SETUP_FILE_NAME, chromeMajor } from './printSetup';

/** Shown where the setup file is offered: an older Chrome ignores the setting, so it has to be updated first. */
export const ChromeTooOld = () => {
  const chrome = chromeMajor();
  if (chrome === null || chrome >= MIN_CHROME_MAJOR) {
    return null;
  }
  return (
    <p className="ff-print-setup-warn">
      This Chrome is version {chrome}. Update it to {MIN_CHROME_MAJOR} or later first (
      <code>chrome://settings/help</code>): older Chrome ignores the setting.
    </p>
  );
};

/** How to set up a packing PC, under the reminder and in View Orders' settings (SSD-7389). */
export const PrintSetupSteps = () => {
  const [manualOpen, setManualOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyCommands = () => {
    void navigator.clipboard
      ?.writeText(POLICY_COMMANDS)
      .then(() => setCopied(true))
      .catch(() => setCopied(false));
  };

  return (
    <ol className="ff-print-setup-steps">
      <li>
        Open the downloaded <code>{SETUP_FILE_NAME}</code>. If Chrome asks, choose <b>Keep</b>; if Windows warns, choose{' '}
        <b>More info › Run anyway</b>, then <b>Yes</b> on the administrator prompt.
      </li>
      <li>
        When the window asks, close every Chrome window and press a key. Once the file has checked the setting, the
        printer and Chrome&apos;s version, Chrome opens View Orders again with a green &quot;set up&quot; note, and the
        yellow reminder stops showing in this Chrome.
      </li>
      <li>
        If the window says there is no printer named <code>{LABEL_PRINTER_NAME}</code>, rename the label printer to
        exactly that in Windows Settings › Printers &amp; scanners and run the file again; until then the reminder keeps
        showing.
      </li>
      <li>Print one order from View Orders. The label should come out with no print dialog.</li>
      <li>
        <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setManualOpen((was) => !was)}>
          {manualOpen ? 'Hide manual setup' : 'The file cannot run on this PC? Set it up by hand'}
        </button>
        {manualOpen && (
          <div>
            Open <b>PowerShell as administrator</b> and run the lines below, then restart Chrome and check that{' '}
            <code>chrome://policy</code> lists SilentPrintingEnabled and DefaultPrinterSelection.
            <pre className="ff-print-setup-code">{POLICY_COMMANDS}</pre>
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={copyCommands}>
              {copied ? 'Copied' : 'Copy commands'}
            </button>
          </div>
        )}
      </li>
    </ol>
  );
};
